module.exports = __webpack_public_path__ + "img/stat-arrow.f5650119.svg";